import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {StorageService} from "../../_services/storage.service";
import { LoginComponent } from 'src/app/views/pages/auth/login/login.component';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private storageService: StorageService,private loginCompenent:LoginComponent) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    var username=route.queryParams.username;
    
    // this.loginCompenent.keyLogin(username)
    if (this.storageService.isLoggedIn()) {
      return true;
    }
     
    this.router.navigate(['/auth/login'], {queryParams: {returnUrl: state.url}});
    return false;
  }
}
